/* Keep the mobile dock's cart badge in step with the header cart bubble.
 * The header is the single source of truth; Dawn replaces that subtree on every
 * cart change, so the observer sits on .header__icons, which survives it. */
(() => {
  if (window.kpMobileDockReady) return;
  window.kpMobileDockReady = true;

  const dockCart = document.querySelector('[data-kp-dock-cart]');
  const dockCount = document.querySelector('[data-kp-dock-cart-count]');
  const headerIcons = document.querySelector('.header__icons');
  if (!dockCart || !dockCount || !headerIcons) return;

  const template = dockCart.dataset.ariaTemplate || 'Cart with [count] items';
  const templateOne = dockCart.dataset.ariaTemplateOne || template;

  const syncCartCount = () => {
    const fullLabel = document.querySelector('#cart-icon-bubble .cart-count-bubble .visually-hidden')?.textContent || '';
    const fullCount = fullLabel.match(/\d+/)?.[0];
    const badge = Number(fullCount || document.querySelector('#cart-icon-bubble .cart-count-bubble [aria-hidden]')?.textContent.replace(/\D+/g, ''));
    const count = Number.isFinite(badge) ? badge : 0;
    dockCount.textContent = String(count);
    const label = count === 1 ? templateOne : template;
    dockCart.setAttribute('aria-label', label.replace('[count]', String(count)));
  };

  new MutationObserver(syncCartCount).observe(headerIcons, {
    childList: true,
    characterData: true,
    subtree: true,
  });
  syncCartCount();
})();
